<template>
    <Appstore/>
</template>

<script>
import { Appstore } from 'shared'

export default {
    name: 'appstore',
    components: {
        Appstore
    },
    created() {
        this.$store.commit('getAppId', [
            {
                value: 6003,
                label: '旅游'
            }
        ])
    }
}
</script>